<template>
    <div v-if="isVisible" id="loading-overlay" class="loading-overlay">
        <div class="spinner"></div>
    </div>
</template>
<script setup>
import { ref, onMounted, onUnmounted } from 'vue';
import eventBus from '@/utils/eventBus';
const isVisible = ref(false);

onMounted(() => {
    try {
        eventBus.on('show-loading', () => {
            isVisible.value = true;
        });

        eventBus.on('hide-loading', () => {
            isVisible.value = false;
        });
    } catch (error) {
        console.error('Error setting up event listeners:', error);
    }
});
onUnmounted(() => {
    eventBus.off('show-loading');
    eventBus.off('hide-loading');
});
</script>
<style scoped>
.loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5); /* Semi-transparent background */
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 900; /* Ensure it is above other elements */
}

.spinner {
    border: 8px solid #f3f3f3; /* Light grey */
    border-top: 8px solid #3498db; /* Blue */
    border-radius: 50%;
    width: 60px;
    height: 60px;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}
</style>